import { DataBean } from "../DataBean";


export class PreparationHiringStageMapping extends DataBean {

    public async getPreparationHiringStageMappingCatalogPorPropiedades(props: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getPreparationHiringStageMappingCatalogPorPropiedades_java.util.Map_Number", [props, maxRows]);
    }

    public async deletePreparationHiringStageMapping(idpreparationhiringstagemapping: number): Promise<any> {
        return this.getCustomService("FinanceCore", "boolean_deletePreparationHiringStageMapping_Number", [idpreparationhiringstagemapping]);
    }

    // public async getRequestNeedCatalogRender(props: any, page: number, rows: number): Promise<any> {
    //     return this.getCustomService("FinanceCore", "java.util.List_getRequestNeedCatalogRender_java.util.Map_Number_Number", [props, page, rows]);
    // }

    public async updatePreparationHiringStageMapping(bean: any): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "com.orange.bean.PreparationHiringStageMapping_updatePreparationHiringStageMapping_com.orange.bean.PreparationHiringStageMapping",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.bean.PreparationHiringStageMapping"
                }
            ]
        );
    }

}